import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

import {
    TAGS_DELETE_TAGS
} from 'Redux/actionTypes';

import {
    tagsDeleteTagsResponse
} from 'Redux/actions';

function* tagsDeleteTagsRequest({ payload }) {
    try {
        const { data } = payload;

        let query = `
            mutation deleteTags (
                $ids: [Int]!
            ) {
                tag: deleteTags (
                    ids: $ids
                )
            }
        `;

        const response = yield call(
            clientMutation,
            query,
            data,
            endpoints.GRAPHQL_GENERAL,
        );

        if (!response || !response.tag) throw 'Error while deleting tags';

        yield put(tagsDeleteTagsResponse({ ...response.tag, error: false }));
    } catch (exc) {
        yield put(tagsDeleteTagsResponse({ error: true }));
        ExceptionManager(exc, 'modules/account/views/tags/components/deleteTags/redux/saga', 'tagsDeleteTagsResponse');
    }
}

function* watchMethods() {
    yield takeEvery(TAGS_DELETE_TAGS, tagsDeleteTagsRequest);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}